module.exports = __webpack_public_path__ + "static/media/google.7cb401f4.svg";